import { createEntityAdapter } from "@reduxjs/toolkit";
import { ControlPoint } from "./dataTypes";

export const controlPointAdapter = createEntityAdapter<ControlPoint>({});
